import {Component} from '@angular/core';
import {AppRoutes} from "../../../enums/routes";
import {
  NavbarItemLargeComponent
} from "../../../x-components/navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../../../x-components/navbar-base/navbar-container/navbar-container.component";

/**
 * Sidebar group for the audit trail. The group itself is gated on the {@link Roles.Auditor} privilege in
 * {@link NavbarService}, so it only appears for auditors (and PlatformOwner/CompanyOwner who hold the role) — the
 * single link inside needs no further permission check.
 */
@Component({
  selector: 'app-navbar-audit',
  templateUrl: './navbar-audit.component.html',
  imports: [NavbarItemLargeComponent, NavbarContainerComponent]
})
export class NavbarAuditComponent {
  protected readonly Routes = AppRoutes;
}
